var render = function render(){var _vm=this,_c=_vm._self._c;return _c('member-slack-id-change',{attrs:{"show":_vm.setShow,"email":_vm.gardener.email,"id":_vm.gardener.id,"role":'gardener',"slack-id":_vm.gardener.slack_id},on:{"update:show":function($event){_vm.setShow=$event},"success":_vm.emitUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }